<template>
  <v-btn v-if="enabled"
         large
         icon
         text
         class="flex-grow-0"
         :dark="dark"
         :light="!dark"
         :color="color"
         :width="size"
         :height="size"
         @click="nav"
  >
    <v-icon>
      {{ icon }}
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'NavigationButton',
  props: {
    dark: { type: Boolean, default: false },
    size: { type: Number, default: null },
    color: { type: String, default: null },
    position: { type: String, default: 'top-left' }
  },
  created() {
    this.icon = this.$store.state.theme.navigationButtonIcon;
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === 'xs';
    },
    enabled() {
      if (!this.isMobile && this.$store.state.theme.navigationDesktop === 'constant') {
        return false;
      }
      if (this.position === 'show') return true;
      return this.$store.state.theme.navigationButton === this.position;
    }
  },
  methods: {
    nav() {
      const { navigation } = this.$store.state.ui;
      this.$store.commit('ui/navigation', !navigation);
    },
  }
};
</script>
